// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3OV8p","list":"styles_list__3nwWI"};